import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as slipLinesSelectors, actions as slipLinesActions } from 'ducks/pickSlipEnquiry/slipLines';
import { fetch } from 'api/pickSlipEnquiry/slipLines';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { selectors as pickSlipSelectors } from 'ducks/pickSlipEnquiry/pickSlipEnquiries';
import { IApplicationState } from 'ducks/reducers';

const params = new URLSearchParams(location.search);

export const mapStateToProps = (state: IApplicationState) => ({
  gridName: 'PSESlipLines',
  columnDefs: slipLinesSelectors.columns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: slipLinesSelectors.gridOptions(state),
  filterRow: slipLinesSelectors.filterRow(state),
  selectedFilters: slipLinesSelectors.selectedFilters(state),
  appliedFilters: slipLinesSelectors.filterRow(state) && filterSelectors.getFilters(state, slipLinesSelectors.filterRow(state).formName),
  reqParams: (pickSlipSelectors.selected(state) || params.get('DespatchId'))
    &&
    {
      DespatchId: (pickSlipSelectors.selected(state) && pickSlipSelectors.selected(state).DespatchId) || params.get('DespatchId')
    },
  keyFields: [{ valueField: 'LineNumber', routeField: 'LineNumber' }],
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: slipLinesActions.setSelected,
  applyFilters: filterActions.applyFilters
};
